module.exports.RADIUS = 6378137;
module.exports.FLATTENING = 1/298.257223563;
module.exports.POLAR_RADIUS = 6356752.3142;



//////////////////
// WEBPACK FOOTER
// ./~/wgs84/index.js
// module id = 545
// module chunks = 2